import "./SideBar.css";

import React, { useContext, useEffect, useRef, useState } from "react";
import {
    adminSubMenus,
    dashboardMap,
    foundationMenus,
} from "../../utils/constants";

import { DashboardContext } from "../Self-Verification Tool/DashboardContext";
import DocumentIcon from "../../assets/DocumentIcon.svg";
import GreyArrowIcon from "../../assets/greyArrow";
import { HeaderContext } from "../../utils/HeaderContext";
import Loader from "./Loader/Loader";
import { MenuContext } from "../DocumentManagementSystem/DocumentMenuContext";
import ModalComponent from "./ModalComponent/ModalComponent";
import { SVTUserContext } from "../../utils/SVTUserContext";
import SidebarEntityVector from "../../resources/sidebarEntityVector";
import SidebarItemVector from "../../resources/sidebarItemVector";
import SidebarMainVector from "../../resources/sidebarMainVector";
import SubmitConfirmation from "../../resources/submitConfirmation";
import { SurveyContext } from "../../utils/SurveyContext";
import useGetEntitiesData from "../../utils/useGetEntitiesData";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SideBar = ({
    isOpen,
    handleExpandDashboard,
    handleDashboardClick,
    handelAdminMenuClick,
    roleName,
    setRoleName,
}) => {
    const [selectedSubMenuId, setSelectedSubMenuId] = useState(null);
    const {
        activeTab,
        setActiveTab,
        selectedEntity,
        setSelectedEntity,
        setIsGuidelinesModalOpen,
    } = useContext(SVTUserContext);
    const [openDocMenuId, setOpenDocMenuId] = useState("all");
    const {
        docMenuItems,
        handleMenuItemClick,
        docSubMenuItems,
        handleSubMenuItemClick,
        handleMenuItemDbClick,
        handleMenuAllItemClick
    } = useContext(MenuContext);
    const location = useLocation();
    const navigateURL = useNavigate();
    const [resources, setResources] = useState([]);
    const [activeModule, setActiveModule] = useState("");
    const [dashBoardMenuItems, setDashBoardMenuItems] = useState([]);
    const { setSelectedDashboard, setDashboardKey, selectedDashboard } =
        React.useContext(DashboardContext);
    const [legalEntities, loading] = useGetEntitiesData(activeModule, roleName);
    const { t, i18n } = useTranslation();
    const [navigateTo, setNavigateTo] = useState("Home");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { surveyTab, setSurveyTab } = useContext(SurveyContext);

    useEffect(() => {
        legalEntities && setSelectedEntity(legalEntities[0]?.organizationId);
    }, [legalEntities]);
    useEffect(() => {
        const storedData = localStorage.getItem("userDetails");
        if (storedData) {
            try {
                const parsed = JSON.parse(storedData);
                setRoleName(parsed?.[0]?.roleName || "");
                setResources(parsed?.[0]?.resources || []);
                const filteredMenuItems = Object.keys(dashboardMap).filter(
                    (key) =>
                        handleDashBoardSubResources(
                            parsed?.[0]?.resources || []
                        ).includes(dashboardMap[key])
                );
                setDashBoardMenuItems(filteredMenuItems);
            } catch (err) {
                console.error("Error parsing user roles:", err);
            }
        }
    }, []);

    const handleDashBoardSubResources = (resources) => {
        const res = resources.flatMap(
            (r) => r.subResources?.map((sub) => sub.subResourceCode) || []
        );
        const dashboardSubResources = res.filter((subResource) =>
            subResource.includes("DASHBOARD")
        );
        return dashboardSubResources;
    };

    useEffect(() => {
        detectActiveModule(location.pathname);
    }, [location, surveyTab]);

    const detectActiveModule = (path) => {
        if (path.includes("/self-verification"))
            setActiveModule("SELFVERIFICATION");
        else if (path.includes("/survey") && surveyTab === "surveyDashboard")
            setActiveModule("SURVEYDASHBOARD");
        else if (path.includes("/survey")) setActiveModule("SURVEY");
        else if (path.includes("/foundation")) setActiveModule("FOUNDATION");
        else if (path.includes("/dms")) setActiveModule("DOCUMENT");
        else if (path.includes("/notification")) setActiveModule("NOTIFICATION");
        else setActiveModule("");
    };

    const showLegalEntities = () => {
        if (loading) return <Loader />;
        return (
            legalEntities &&
            legalEntities.map((entity) => (
                <div
                    className={
                        selectedEntity === entity.organizationId
                            ? "entity-selected-li"
                            : "entity-li"
                    }
                    key={entity.organizationId}
                    onClick={() => setSelectedEntity(entity.organizationId)}
                >
                    <GreyArrowIcon
                        color={
                            selectedEntity === entity.organizationId
                                ? "red"
                                : "grey"
                        }
                    />
                    {entity.organizationName}
                </div>
            ))
        );
    };

    const showSelectedLegalEntity = () => {
        let entityName;
        if (legalEntities && selectedEntity) {
            entityName = legalEntities.find(
                (entity) => entity.organizationId === selectedEntity
            )?.organizationName;
        } else entityName = "";
        return (
            <li className="entity-selected-li">
                <GreyArrowIcon color="red" />
                {entityName}
            </li>
        );
    };
    const dashboardTranslationKeyMap = {
        "Hitachi Overall Dashboard": "hitachiDashboard",
        "Entity Dashboard": "entityDashboard",
        "Sector Dashboard": "sectorDashboard",
        "Business Unit Dashboard": "businessUnitDashboard",
        "Sub Business Unit Dashboard": "subBusinessUnitDashboard",
        "Region Dashboard": "regionDashboard",
        "Country Dashboard": "countryDashboard",
    };

    const onHomeClick = () => {
        if (activeTab === "Tab3") {
            setNavigateTo("Home");
            setIsModalOpen(true);
        } else if (surveyTab === "surveyDashboard") {
            setNavigateTo("Home");
            setSurveyTab("surveyManagement");
        } else navigateURL("/home");
    };
    const onDashboardClick = () => {
        if (activeTab === "Tab3") {
            setNavigateTo("Dashboard");
            setIsModalOpen(true);
        } else handleExpandDashboard();
    };
    const handleModalClose = () => {
        setIsModalOpen(false);
    };

    const handleModalConfirm = async () => {
        setActiveTab("Tab1");
        setSelectedEntity(null);
        navigateTo === "Home" ? navigateURL("/home") : handleExpandDashboard();
        setIsModalOpen(false);
    };

    const getDisplayName = (item, lang) => {
            if (lang === "jp" && item.name_JP && item.name_JP.trim().toLowerCase() !== "undefined") {
                return item.name_JP;
            } else if (lang === "ch" && item.name_CH && item.name_CH.trim().toLowerCase() !== "undefined") {
                return item.name_CH;
            } else if (lang === "en" && item.name && item.name.trim().toLowerCase() !== "undefined") {
                return item.name;
            }
        return null;
    };

    return (
        <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
            <div className="sidebar-content sidebar">
                <ul className="sidebar-list">
                    <li className="sidebar-main-list" onClick={onHomeClick}>
                        <SidebarItemVector />
                        {t("home")}
                    </li>

                    {/* Dashboard  screens */}
                    {(activeModule === "SELFVERIFICATION" ||
                        location.pathname.includes("/dashboard")) && (
                        <li
                            className={`sidebar-main-list${location.pathname.includes("/dashboard") ? " open" : ""}`}
                            onClick={onDashboardClick}
                        >
                            <SidebarItemVector />
                            {t("dashboard")}
                            {location.pathname.includes("/dashboard") && (
                                <ul className="submenu">
                                    {dashBoardMenuItems.map((item, index) => (
                                        <li
                                            key={index}
                                            className={`dashboard-li ${selectedDashboard === item ? "selected-dashboard" : ""}`}
                                            onClick={() =>
                                                handleDashboardClick(item)
                                            }
                                        >
                                            <GreyArrowIcon
                                                color={
                                                    selectedDashboard === item
                                                        ? "red"
                                                        : "grey"
                                                }
                                            />
                                            {t(
                                                dashboardTranslationKeyMap[
                                                    item
                                                ] || item
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    )}

                    {/* Admin screens */}
                    {(roleName === "ADMIN" || roleName === "TOOLADMIN") && (
                        <>
                            {location.pathname !== "/user/self-verification" &&
                                location.pathname.includes(
                                    "/admin/self-verification"
                                ) &&
                                adminSubMenus?.map((item, index) => (
                                    <li
                                        className={
                                            location.pathname.startsWith(
                                                item.path
                                            )
                                                ? "open"
                                                : "sidebar-main-list"
                                        }
                                        key={index}
                                        onClick={() =>
                                            handelAdminMenuClick(item.path)
                                        }
                                    >
                                        <SidebarItemVector />
                                        {t(item.translationKey || item.page)}
                                    </li>
                                ))}

                            {/* Admin DMS screens */}
                            {activeModule === "DOCUMENT" && (
                                <li
                                    className={
                                        activeModule === "DOCUMENT"
                                            ? "open"
                                            : ""
                                    }
                                    onClick={() => {
                                        navigateURL("/admin/dms");
                                    }}
                                >
                                    <SidebarItemVector />
                                    {t("documentManagement")}
                                </li>
                            )}

                            {/* Admin Survey screens */}
                            {(activeModule === "SURVEYDASHBOARD" ||
                                activeModule === "SURVEY") && (
                                <li
                                    className={
                                        activeModule === "SURVEY"
                                            ? "open"
                                            : "sidebar-main-list"
                                    }
                                    onClick={() => {
                                        setSurveyTab("surveyManagement");
                                        navigateURL("/admin/survey");
                                    }}
                                >
                                    <SidebarItemVector />
                                    {t("surveyManagement")}
                                </li>
                            )}
                            {activeModule === "SURVEYDASHBOARD" && (
                                <li
                                    className={
                                        activeModule === "SURVEYDASHBOARD"
                                            ? "open"
                                            : "sidebar-main-list"
                                    }
                                >
                                    <SidebarItemVector />
                                    {t("surveyDashboard")}
                                </li>
                            )}

                            {/* Admin Foundation screens */}
                            {activeModule === "FOUNDATION" && (
                                <>
                                    {foundationMenus.map((item, index) => (
                                        <li
                                            className={
                                                location.pathname.startsWith(
                                                    item.path
                                                )
                                                    ? "open"
                                                    : "sidebar-main-list"
                                            }
                                            key={index}
                                            onClick={() =>
                                                navigateURL(item.path)
                                            }
                                        >
                                            <SidebarItemVector />
                                            {t(
                                                item.translationKey ||
                                                    item.label
                                            )}
                                        </li>
                                    ))}
                                </>
                            )}

                            {/* Admin Notification screens */}
                            {activeModule === "NOTIFICATION" && (
                                <li
                                    className={
                                        activeModule === "NOTIFICATION"
                                            ? "open"
                                            : ""
                                    }
                                    onClick={() => {
                                        navigateURL("/admin/notification/notification-management");
                                    }}
                                >
                                    <SidebarItemVector />
                                    {t("notificationManagement")}
                                </li>
                            )} 
                        </>
                    )}
                </ul>
                {/* User  screens */}
                {roleName !== "ADMIN" && roleName !== "TOOLADMIN" && (
                    <>
                        {(activeModule === "SELFVERIFICATION" ||
                            location.pathname.includes("/user/dashboard")) &&
                            roleName.includes("PIC") && (
                                <>
                                    <div className="legal-entities-div">
                                        <div
                                            className={
                                                activeModule ===
                                                "SELFVERIFICATION"
                                                    ? "open"
                                                    : "sidebar-main-list"
                                            }
                                            onClick={() => {
                                                setActiveTab("Tab1");
                                                setSelectedEntity(null);
                                                navigateURL(
                                                    "/user/self-verification"
                                                );
                                            }}
                                        >
                                            {" "}
                                            <SidebarItemVector />{" "}
                                            {t("assessment")}
                                        </div>
                                        {location.pathname.includes(
                                            "/user/self-verification"
                                        ) && (
                                            <>
                                                {activeTab === "Tab3" ||
                                                activeTab === "Tab4"
                                                    ? showSelectedLegalEntity()
                                                    : showLegalEntities()}
                                            </>
                                        )}
                                    </div>
                                    <div className="guidelines-list">
                                        <div
                                            onClick={() =>
                                                setIsGuidelinesModalOpen(true)
                                            }
                                        >
                                            {t("guidelines")}
                                        </div>
                                    </div>
                                </>
                            )}
                        {activeModule === "SURVEY" && (
                            <ul className="sidebar-list">
                                <li
                                    className={
                                        activeModule === "SURVEY"
                                            ? "open sidebar-dms-list"
                                            : "sidebar-dms-list"
                                    }
                                    onClick={() => {
                                        navigateURL("/user/survey");
                                    }}
                                >
                                    <SidebarItemVector />
                                    {t("survey")}
                                </li>
                            </ul>
                        )}
                        {activeModule === "DOCUMENT" && (
                            <ul className="sidebar-dms-list">
                                <li
                                    onClick={() => {
                                        setOpenDocMenuId("all"); 
                                        handleMenuAllItemClick('');
                                    }}
                                    className={
                                        openDocMenuId === "all"
                                            ? "open"
                                            : "dms-list-item"
                                    }
                                >
                                    <img
                                        src={DocumentIcon}
                                        alt="folder"
                                        className="doc-icon"
                                    />
                                    {t("allDocuments")}
                                </li>
                                {docMenuItems.map((item) => (
                                    <li
                                        key={item.id}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            const isOpening = openDocMenuId !== item.id;
                                            setSelectedSubMenuId(null);
                                            if (isOpening) {
                                                handleMenuItemClick(item.id);
                                                handleMenuItemDbClick(item.id);
                                                setOpenDocMenuId(item.id);
                                            } else {
                                                // Do not remove 'open' class, keep openDocMenuId as is
                                                handleMenuItemDbClick(item.id);
                                            }   

                                        }}
                                        className={openDocMenuId === item.id ? "open" : "dms-list-item"}
                                    >
                                        <img
                                            src={DocumentIcon}
                                            alt="folder"
                                            className="doc-icon"
                                        />
                                        {getDisplayName(item, i18n.language)}

                                        {openDocMenuId === item.id && (
                                            <ul class="nested-dms-list">
                                                {docSubMenuItems
                                                    .filter(
                                                        (val) =>
                                                            val.documentTypeId ===
                                                            item.id
                                                    )
                                                    .map((val) => (
                                                        <li
                                                            key={val.id}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleSubMenuItemClick(
                                                                    val.id,
                                                                    item.id
                                                                );
                                                                setSelectedSubMenuId(
                                                                    val.id
                                                                );
                                                            }}
                                                            className={
                                                                val.id ===
                                                                selectedSubMenuId
                                                                    ? "selected-nested-dms"
                                                                    : ""
                                                            }
                                                        >
                                                            <img
                                                                src={
                                                                    DocumentIcon
                                                                }
                                                                alt="folder"
                                                                className="doc-icon"
                                                            />
                                                            {getDisplayName(val, i18n.language)}
                                                        </li>
                                                    ))}
                                            </ul>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </>
                )}
            </div>
            <ModalComponent
                isOpen={isModalOpen}
                onClose={handleModalClose}
                modalTitle={
                    <span style={{ color: "black", paddingLeft: "1em" }}>
                               {t("cancelConfirmation")}
                    </span>
                }
                modalText={
                    <span style={{ color: "black" }}>
                       {t("cancelConfirmationText")}
                    </span>
                }
                buttons={[
                    <button
                        key="confirm"
                        className="saveButton"
                        onClick={handleModalConfirm}
                    >
                        {t("confirm")}
                    </button>,
                ]}
            />
        </div>
    );
};

const Hamburger = ({ onClick, isOpen }) => {
    const { t } = useTranslation();
    const hamburgerColor = isOpen ? "#F8F8F8" : "#454647";
    const hamburgerStyle = {
        borderBottom: isOpen ? "1px solid #212121" : "none",
    };
    return (
        <div>
            <div className="hamburger" style={hamburgerStyle} onClick={onClick}>
                <SidebarMainVector color={hamburgerColor} />{" "}
                <span style={{ color: hamburgerColor }}>{t("gcp")}</span>
            </div>
        </div>
    );
};

const SidebarWrapper = () => {
    const [isOpen, setIsOpen] = React.useState(true);
    const [roleName, setRoleName] = useState("");
    const { setSelectedDashboard, setDashboardKey } =
        React.useContext(DashboardContext);
    const location = useLocation();
    const navigate = useNavigate();
    const { updateState } = useContext(HeaderContext);
    const isExternalUserSurvey =
        sessionStorage.getItem("isExternalUserSurvey") || "false";

    React.useEffect(() => {
        updateState(isOpen);
    }, [isOpen]);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const handleExpandDashboard = () => {
        if (!location.pathname.includes("/dashboard")) {
            if (roleName !== "ADMIN" && roleName !== "TOOLADMIN") {
                navigate("/user/dashboard");
            } else {
                navigate("/admin/self-verification/dashboard");
            }
        }
    };

    const handleDashboardClick = (item) => {
        setSelectedDashboard(item);
        setDashboardKey((prevKey) => prevKey + 1);
        if (roleName !== "ADMIN" && roleName !== "TOOLADMIN") {
            navigate("/user/dashboard");
        } else {
            navigate("/admin/self-verification/dashboard");
        }
    };

    const handelAdminMenuClick = (path) => {
        navigate(path);
    };

    return (
        <div className="sidebar-container">
            {isExternalUserSurvey === "false" && (
                <>
                    <Hamburger onClick={toggleSidebar} isOpen={isOpen} />
                    <SideBar
                        isOpen={isOpen}
                        handleExpandDashboard={handleExpandDashboard}
                        handleDashboardClick={handleDashboardClick}
                        handelAdminMenuClick={handelAdminMenuClick}
                        roleName={roleName}
                        setRoleName={setRoleName}
                    />
                </>
            )}
        </div>
    );
};

export default SidebarWrapper;
